import React, { useState } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { Grid, FormControl, FormHelperText, IconButton, Box, Snackbar } from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import { useDropzone } from 'react-dropzone';
import { getIn } from 'formik';
import useStyles from './DragDrop.style';
import { isFile } from '../../utils';
import PictureAsPdfOutlinedIcon from '@material-ui/icons/PictureAsPdfOutlined';
import InsertDriveFileIcon from '@material-ui/icons/InsertDriveFile';
import AddIcon from '@material-ui/icons/Add';
import DeleteIcon from '@material-ui/icons/Delete';

const Dropzone = ({
  field: { name, value },
  form: { setFieldTouched, setFieldValue, touched, errors }, // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.
  dropzonenote,
  thumb,
  thumbInner,
  img,
  id,
  fromEditScreen,
  errorMessage,
  disabled,
  maxFileAttachments = 5,
  multiple,
  maxSizeError = null,
  ...props
}) => {
  const classes = useStyles();
  const maxFiles = multiple ? maxFileAttachments : 1;
  const error = getIn(touched, name) && getIn(errors, name);
  const [state, setState] = useState({
    show: false,
    message: '',
  });

  const { show, message } = state;
  const handleClose = () => {
    setState({ ...state, show: false });
  };
  const { getRootProps, getInputProps, open } = useDropzone({
    // Disable click and keydown behavior
    noClick: true,
    noKeyboard: true,
    onDragOver: () => {
      setFieldTouched(name, true, true);
    },
    onDrop: (acceptedFilesMain, rejectedFiles) => {
      let acceptedFiles = [...acceptedFilesMain];
      if (acceptedFiles.length > 0) {
        if ((value ? value.length : 0) + acceptedFiles.length <= maxFiles) {
          for (let i = 0; i < acceptedFiles.length; i++) {
            if (acceptedFiles[i].size > 20971520) {
              acceptedFiles[i] = null;
              setState({
                ...state,
                show: true,
                message: 'Individual file size should not exceed 20MB',
              });
            } else {
              let mimeFlag = false;
              let blob = acceptedFiles[i];
              let header = '';
              let fileReader = new FileReader();
              fileReader.onloadend = function (e) {
                let arr = new Uint8Array(e.target.result).subarray(0, 4);
                for (const item of arr) {
                  header += item.toString(16);
                }

                if (
                  header == '4d5a900' ||
                  header == '3c3f7068' ||
                  header == '2428646f' ||
                  header == '3c21444f'
                ) {
                  mimeFlag = true;
                  window.location.reload();
                }
                if (!mimeFlag) {
                  acceptedFiles[i].attachedTime = moment().unix() + i;
                  let updatedAcceptedFiles = [...acceptedFiles].filter((e) => e != null);
                  if (value && value.length > 0) {
                    setFieldValue(name, [...value, ...updatedAcceptedFiles]);
                  } else {
                    setFieldValue(name, [...updatedAcceptedFiles]);
                  }
                }
              };
              fileReader.readAsArrayBuffer(blob);
            }
          }
        } else {
          setState({
            ...state,
            show: true,
            message: `Number of files should not be more than ${maxFiles}`,
          });
        }
      }
      if (rejectedFiles.length > 0) {
        if (rejectedFiles[0].size <= props.maxSize) {
          setState({ ...state, show: true, message: errorMessage });
        } else {
          setState({
            ...state,
            show: true,
            message: maxSizeError || 'Size exceeds 20MB, please select an alternate file.',
          });
        }
      }
      setTimeout(() => {
        setFieldTouched(name, true, true);
      }, 1000);
    },
    ...props,
  });

  const onDelete = (index) => {
    let filteredVal = value.filter((_, i) => i !== index);
    setFieldValue(name, filteredVal);
  };

  /*
 DESC: The reason to create the funciton was because of the rendering problems on the ui side while
 deleting the video in particular pattern, this handler just over comes the issue
*/

  return (
    <FormControl className={classes.form} error={!!error}>
      <Snackbar open={show} autoHideDuration={6000} onClose={handleClose}>
        <Alert elevation={6} variant="filled" onClose={handleClose} severity="error">
          {message}
        </Alert>
      </Snackbar>
      <Grid item xs={12}>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <div
              className={classes.dropzonestyle}
              style={
                disabled
                  ? {
                      backgroundColor: 'rgba(227, 226, 225, 1)',
                    }
                  : {}
              }
              {...getRootProps({})}
            >
              <input {...getInputProps()} id="dropped" />
              <div className={classes.dropzonetitle}>
                {' '}
                <Box
                  disabled={disabled || (value && value.length == maxFiles)}
                  onClick={open}
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                  height={1}
                  width={1}
                >
                  <AddIcon />
                </Box>
              </div>
            </div>
            {dropzonenote && (
              <aside>
                <p className={classes.dropzonenote}> {dropzonenote} </p>
              </aside>
            )}
            {!!error && <FormHelperText error> {error} </FormHelperText>}
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <div className={classes.thumbsContainer}>
              <ul style={{ padding: 0, margin: 0, width: '100%' }}>
                {value &&
                  value.length > 0 &&
                  value.map((eachVal, index) => (
                    <li className={classes.thumb}>
                      <IconButton
                        aria-label="delete"
                        onClick={() => onDelete(index)}
                        className={classes.cross}
                        style={{ zIndex: 7 }}
                        color="primary"
                      >
                        <DeleteIcon />
                      </IconButton>

                      <div className={classes.thumbInner}>
                        <If
                          condition={eachVal.type == 'video/mp4' || eachVal.mimetype == 'video/mp4'}
                        >
                          <video
                            style={{ width: '100px', height: 'auto' }}
                            controls={false}
                            muted={false}
                            src={isFile(eachVal) ? URL.createObjectURL(eachVal) : '' + eachVal.path}
                          >
                            <track kind="captions" label="No captions available" src="" default />
                            Your browser does not support the video tag.
                          </video>
                        </If>
                        <If
                          condition={
                            eachVal.type == 'application/pdf' ||
                            eachVal.mimetype == 'application/pdf' ||
                            eachVal?.name?.toLowerCase()?.includes('.pdf')
                          }
                        >
                          <PictureAsPdfOutlinedIcon style={{ fill: '#003c6f', fontSize: 57 }} />
                        </If>
                        <If
                          condition={
                            (eachVal.type || eachVal.mimetype)?.includes('image') ||
                            eachVal?.name?.toLowerCase()?.includes('.jpg') ||
                            eachVal?.name?.toLowerCase()?.includes('.jpeg') ||
                            eachVal?.name?.toLowerCase()?.includes('.png')
                          }
                        >
                          <img
                            style={{ width: '100%', height: 'auto' }}
                            className={classes.img}
                            src={isFile(eachVal) ? URL.createObjectURL(eachVal) : '' + eachVal.path}
                            alt="Drag Drop"
                          />
                        </If>
                        <If
                          condition={
                            !(
                              (eachVal.type || eachVal.mimetype)?.includes('image') ||
                              eachVal?.name?.toLowerCase()?.includes('.jpg') ||
                              eachVal?.name?.toLowerCase()?.includes('.jpeg') ||
                              eachVal?.name?.toLowerCase()?.includes('.png') ||
                              eachVal.type == 'application/pdf' ||
                              eachVal.mimetype == 'application/pdf' ||
                              eachVal?.name?.toLowerCase()?.includes('.pdf') ||
                              eachVal.type == 'video/mp4' ||
                              eachVal.mimetype == 'video/mp4'
                            )
                          }
                        >
                          <InsertDriveFileIcon style={{ fill: '#003c6f', fontSize: 57 }} />
                        </If>
                      </div>
                    </li>
                  ))}
              </ul>
            </div>
          </Grid>
        </Grid>
      </Grid>
    </FormControl>
  );
};

Dropzone.propTypes = {
  field: PropTypes.shape({
    name: PropTypes.string.isRequired,
  }).isRequired,
  form: PropTypes.shape({
    setFieldValue: PropTypes.func.isRequired,
    touched: PropTypes.object.isRequired,
  }).isRequired,
  dropzonenote: PropTypes.string,
};

Dropzone.defaultProps = {
  dropzonenote: '',
};

export default Dropzone;
